import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import dmnoidungchuyenmonthuchanhService from "services/hrm/dmnoidungchuyenmonthuchanhService";

export const create = createAsyncThunk(
  "noidungchuyenmonthuchanhSlice/create",
  async (data, { rejectWithValue }) => {
    try {
      const {onSuccess}= data
      const response = await dmnoidungchuyenmonthuchanhService.create(data);
      if(onSuccess)onSuccess(response.data)
      return response.data?.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const update = createAsyncThunk(
  "noidungchuyenmonthuchanhSlice/update",
  async (data, { rejectWithValue }) => {
    try {
      const response = await dmnoidungchuyenmonthuchanhService.update(data);
      return response.data.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);


export const deletebyid = createAsyncThunk(
  "noidungchuyenmonthuchanhSlice/deletebyid",
  async (data, { rejectWithValue }) => {
    try {
      const {onSuccess,id}= data
      const response = await dmnoidungchuyenmonthuchanhService.delete(id);
      if(onSuccess)onSuccess(response.data)
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getbyid = createAsyncThunk(
  "noidungchuyenmonthuchanhSlice/getbyid",
  async (data, { rejectWithValue }) => {
    try {
      const {onSuccess,id}= data
      const response = await dmnoidungchuyenmonthuchanhService.getbyid(id);
      if(onSuccess)onSuccess(response.data)
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);


export const getall = createAsyncThunk(
  "noidungchuyenmonthuchanhSlice/getall",
  async (data, { rejectWithValue }) => {
    try {
      const response = await dmnoidungchuyenmonthuchanhService.getall();
      return response.data.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);


const initialState = {
  loading: false,
  danhsachnoidungchuyenmonthuchanh: [],
  noidungchuyenmondetail:{},

};

const noidungchuyenmonthuchanhSlice = createSlice({
  name: "noidungchuyenmonthuchanhSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(create.pending, (state) => {
        state.loading = true;
      })
      .addCase(create.fulfilled, (state, action) => {
        state.loading = false;
        
      })
      .addCase(create.rejected, (state) => {
        state.loading = false;
      })

      .addCase(update.pending, (state) => {
        state.loading = true;
      })
      .addCase(update.fulfilled, (state, action) => {
        state.loading = false;

      })
      .addCase(update.rejected, (state) => {
        state.loading = false;
      })

      .addCase(deletebyid.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletebyid.fulfilled, (state, action) => {
        state.loading = false;
        
      })
      .addCase(deletebyid.rejected, (state) => {
        state.loading = false;
      })

      .addCase(getbyid.pending, (state) => {
        state.loading = true;
      })
      .addCase(getbyid.fulfilled, (state, action) => {
        state.loading = false;
        state.noidungchuyenmondetail = action.payload;
      })
      .addCase(getbyid.rejected, (state) => {
        state.loading = false;
      })
      
      .addCase(getall.pending, (state) => {
        state.loading = true;
      })
      .addCase(getall.fulfilled, (state, action) => {
        state.loading = false;
        state.danhsachnoidungchuyenmonthuchanh= action.payload

      })
      .addCase(getall.rejected, (state) => {
        state.loading = false;
      })
      
      ;
  },
});
// eslint-disable-next-line no-empty-pattern
export const {} = noidungchuyenmonthuchanhSlice.actions;

export default noidungchuyenmonthuchanhSlice.reducer;
